import React, { useState } from 'react';
import soundService from '../utils/soundService';

// Dictionary data organized by categories
const categories = {
  greetings: {
    name: "Greetings",
    nameSi: "සුභ පැතුම්",
    icon: "👋",
    color: "#4CAF50",
    words: [
      { english: "hello", sinhala: "ආයුබෝවන්", pronunciation: "aa-yoo-boh-vuhn" },
      { english: "hi", sinhala: "හායි", pronunciation: "haa-yee" },
      { english: "goodbye", sinhala: "ගිහින් එන්නම්", pronunciation: "gee-hin ehn-nuhm" },
      { english: "bye", sinhala: "බයි", pronunciation: "bai" },
      { english: "thank you", sinhala: "ස්තූතියි", pronunciation: "sthoo-thee-yee" },
      { english: "please", sinhala: "කරුණාකර", pronunciation: "kuh-roo-naa-kuh-ruh" },
      { english: "sorry", sinhala: "සමාවන්න", pronunciation: "suh-maa-vuhn-nuh" },
      { english: "yes", sinhala: "ඔව්", pronunciation: "ohv" },
      { english: "no", sinhala: "නැහැ", pronunciation: "neh-heh" },
      { english: "okay", sinhala: "හරි", pronunciation: "huh-ree" },
      { english: "welcome", sinhala: "ආයුබෝවන්", pronunciation: "aa-yoo-boh-vuhn" },
      { english: "good morning", sinhala: "සුභ උදෑසනක්", pronunciation: "soo-buh oo-deh-suh-nuhk" },
      { english: "good night", sinhala: "සුභ රාත්‍රියක්", pronunciation: "soo-buh raa-three-yuhk" },
      { english: "how are you", sinhala: "කොහොමද?", pronunciation: "koh-hoh-muh-duh" },
      { english: "i am fine", sinhala: "මම හොඳින්", pronunciation: "muh-muh hohn-din" },
    ]
  },
  family: {
    name: "Family",
    nameSi: "පවුල",
    icon: "👨‍👩‍👧‍👦",
    color: "#E91E63",
    words: [
      { english: "mother", sinhala: "අම්මා", pronunciation: "uhm-maa" },
      { english: "father", sinhala: "තාත්තා", pronunciation: "thaa-thaa" },
      { english: "sister", sinhala: "අක්කා/නංගි", pronunciation: "uhk-kaa/nuhn-gee" },
      { english: "brother", sinhala: "අයියා/මල්ලි", pronunciation: "uh-yee-yaa/muhl-lee" },
      { english: "grandmother", sinhala: "ආච්චි", pronunciation: "aach-chee" },
      { english: "grandfather", sinhala: "සීයා", pronunciation: "see-yaa" },
      { english: "uncle", sinhala: "මාමා", pronunciation: "maa-maa" },
      { english: "aunt", sinhala: "නැන්දා", pronunciation: "nehn-daa" },
      { english: "son", sinhala: "පුතා", pronunciation: "poo-thaa" },
      { english: "daughter", sinhala: "දුව", pronunciation: "doo-vuh" },
      { english: "husband", sinhala: "සැමියා", pronunciation: "seh-mee-yaa" },
      { english: "wife", sinhala: "බිරිඳ", pronunciation: "bee-rin-duh" },
      { english: "baby", sinhala: "බබා", pronunciation: "buh-baa" },
      { english: "child", sinhala: "ළමයා", pronunciation: "luh-muh-yaa" },
    ]
  },
  numbers: {
    name: "Numbers",
    nameSi: "අංක",
    icon: "🔢",
    color: "#2196F3",
    words: [
      { english: "one", sinhala: "එක", pronunciation: "eh-kuh" },
      { english: "two", sinhala: "දෙක", pronunciation: "deh-kuh" },
      { english: "three", sinhala: "තුන", pronunciation: "thoo-nuh" },
      { english: "four", sinhala: "හතර", pronunciation: "huh-thuh-ruh" },
      { english: "five", sinhala: "පහ", pronunciation: "puh-huh" },
      { english: "six", sinhala: "හය", pronunciation: "huh-yuh" },
      { english: "seven", sinhala: "හත", pronunciation: "huh-thuh" },
      { english: "eight", sinhala: "අට", pronunciation: "uh-tuh" },
      { english: "nine", sinhala: "නවය", pronunciation: "nuh-vuh-yuh" },
      { english: "ten", sinhala: "දහය", pronunciation: "duh-huh-yuh" },
      { english: "twenty", sinhala: "විස්ස", pronunciation: "vis-suh" },
      { english: "fifty", sinhala: "පනහ", pronunciation: "puh-nuh-huh" },
      { english: "hundred", sinhala: "සියය", pronunciation: "see-yuh-yuh" },
      { english: "thousand", sinhala: "දහස", pronunciation: "duh-huh-suh" },
    ]
  },
  colors: {
    name: "Colors",
    nameSi: "වර්ණ",
    icon: "🎨",
    color: "#9C27B0",
    words: [
      { english: "red", sinhala: "රතු", pronunciation: "ruh-thoo" },
      { english: "blue", sinhala: "නිල්", pronunciation: "nil" },
      { english: "green", sinhala: "කොළ", pronunciation: "koh-luh" },
      { english: "yellow", sinhala: "කහ", pronunciation: "kuh-huh" },
      { english: "white", sinhala: "සුදු", pronunciation: "soo-doo" },
      { english: "black", sinhala: "කළු", pronunciation: "kuh-loo" },
      { english: "orange", sinhala: "තැඹිලි", pronunciation: "thehm-bee-lee" },
      { english: "pink", sinhala: "රෝස", pronunciation: "roh-suh" },
      { english: "purple", sinhala: "දම්", pronunciation: "duhm" },
      { english: "brown", sinhala: "දුඹුරු", pronunciation: "doom-boo-roo" },
      { english: "gray", sinhala: "අළු", pronunciation: "uh-loo" },
      { english: "gold", sinhala: "රන්", pronunciation: "ruhn" },
    ]
  },
  animals: {
    name: "Animals",
    nameSi: "සතුන්",
    icon: "🐾",
    color: "#FF9800",
    words: [
      { english: "dog", sinhala: "බල්ලා", pronunciation: "buhl-laa" },
      { english: "cat", sinhala: "පූසා", pronunciation: "poo-saa" },
      { english: "bird", sinhala: "කුරුල්ලා", pronunciation: "koo-rool-laa" },
      { english: "fish", sinhala: "මාළුවා", pronunciation: "maa-loo-vaa" },
      { english: "elephant", sinhala: "අලියා", pronunciation: "uh-lee-yaa" },
      { english: "monkey", sinhala: "වඳුරා", pronunciation: "vuhn-doo-raa" },
      { english: "cow", sinhala: "හරකා", pronunciation: "huh-ruh-kaa" },
      { english: "horse", sinhala: "අශ්වයා", pronunciation: "uhsh-vuh-yaa" },
      { english: "lion", sinhala: "සිංහයා", pronunciation: "sin-huh-yaa" },
      { english: "tiger", sinhala: "කොටියා", pronunciation: "koh-tee-yaa" },
      { english: "bear", sinhala: "වලහා", pronunciation: "vuh-luh-haa" },
      { english: "deer", sinhala: "මුවා", pronunciation: "moo-vaa" },
      { english: "rabbit", sinhala: "හාවා", pronunciation: "haa-vaa" },
      { english: "snake", sinhala: "සර්පයා", pronunciation: "suhr-puh-yaa" },
      { english: "butterfly", sinhala: "සමනලයා", pronunciation: "suh-muh-nuh-luh-yaa" },
      { english: "peacock", sinhala: "මොණරා", pronunciation: "moh-nuh-raa" },
      { english: "parrot", sinhala: "ගිරවා", pronunciation: "gee-ruh-vaa" },
      { english: "crow", sinhala: "කපුටා", pronunciation: "kuh-poo-taa" },
    ]
  },
  food: {
    name: "Food & Drinks",
    nameSi: "ආහාර සහ පාන",
    icon: "🍽️",
    color: "#F44336",
    words: [
      { english: "rice", sinhala: "බත්", pronunciation: "buhth" },
      { english: "water", sinhala: "වතුර", pronunciation: "vuh-thoo-ruh" },
      { english: "tea", sinhala: "තේ", pronunciation: "thay" },
      { english: "coffee", sinhala: "කෝපි", pronunciation: "koh-pee" },
      { english: "milk", sinhala: "කිරි", pronunciation: "kee-ree" },
      { english: "bread", sinhala: "පාන්", pronunciation: "paan" },
      { english: "egg", sinhala: "බිත්තර", pronunciation: "bith-thuh-ruh" },
      { english: "meat", sinhala: "මස්", pronunciation: "muhs" },
      { english: "fruit", sinhala: "පලතුරු", pronunciation: "puh-luh-thoo-roo" },
      { english: "vegetable", sinhala: "එළවළු", pronunciation: "eh-luh-vuh-loo" },
      { english: "banana", sinhala: "කෙසෙල්", pronunciation: "keh-sehl" },
      { english: "mango", sinhala: "අඹ", pronunciation: "uhm-buh" },
      { english: "coconut", sinhala: "පොල්", pronunciation: "pohl" },
      { english: "sugar", sinhala: "සීනි", pronunciation: "see-nee" },
      { english: "salt", sinhala: "ලුණු", pronunciation: "loo-noo" },
      { english: "cake", sinhala: "කේක්", pronunciation: "kayk" },
      { english: "soup", sinhala: "සුප්", pronunciation: "soop" },
      { english: "juice", sinhala: "යුෂ", pronunciation: "yoo-shuh" },
    ]
  },
  bodyParts: {
    name: "Body Parts",
    nameSi: "ශරීර කොටස්",
    icon: "🫀",
    color: "#795548",
    words: [
      { english: "head", sinhala: "ඔළුව", pronunciation: "oh-loo-vuh" },
      { english: "eye", sinhala: "ඇස", pronunciation: "eh-suh" },
      { english: "ear", sinhala: "කන", pronunciation: "kuh-nuh" },
      { english: "nose", sinhala: "නාසය", pronunciation: "naa-suh-yuh" },
      { english: "mouth", sinhala: "කට", pronunciation: "kuh-tuh" },
      { english: "hand", sinhala: "අත", pronunciation: "uh-thuh" },
      { english: "foot", sinhala: "පාදය", pronunciation: "paa-duh-yuh" },
      { english: "face", sinhala: "මුහුණ", pronunciation: "moo-hoo-nuh" },
      { english: "hair", sinhala: "කෙස්", pronunciation: "kehs" },
      { english: "neck", sinhala: "බෙල්ල", pronunciation: "behl-luh" },
      { english: "shoulder", sinhala: "උරහිස", pronunciation: "oo-ruh-hee-suh" },
      { english: "finger", sinhala: "ඇඟිල්ල", pronunciation: "ehn-geel-luh" },
      { english: "stomach", sinhala: "බඩ", pronunciation: "buh-duh" },
      { english: "heart", sinhala: "හදවත", pronunciation: "huh-duh-vuh-thuh" },
      { english: "brain", sinhala: "මොළය", pronunciation: "moh-luh-yuh" },
    ]
  },
  nature: {
    name: "Nature",
    nameSi: "ස්වභාවය",
    icon: "🌿",
    color: "#4CAF50",
    words: [
      { english: "sun", sinhala: "හිරු", pronunciation: "hee-roo" },
      { english: "moon", sinhala: "හඳ", pronunciation: "huhn-duh" },
      { english: "star", sinhala: "තරුව", pronunciation: "thuh-roo-vuh" },
      { english: "sky", sinhala: "අහස", pronunciation: "uh-huh-suh" },
      { english: "rain", sinhala: "වැස්ස", pronunciation: "vehs-suh" },
      { english: "cloud", sinhala: "වලාකුළ", pronunciation: "vuh-laa-koo-luh" },
      { english: "tree", sinhala: "ගස", pronunciation: "guh-suh" },
      { english: "flower", sinhala: "මල", pronunciation: "muh-luh" },
      { english: "river", sinhala: "ගඟ", pronunciation: "guhn-guh" },
      { english: "sea", sinhala: "මුහුද", pronunciation: "moo-hoo-duh" },
      { english: "mountain", sinhala: "කන්ද", pronunciation: "kuhn-duh" },
      { english: "earth", sinhala: "පොළොව", pronunciation: "poh-loh-vuh" },
      { english: "forest", sinhala: "වනය", pronunciation: "vuh-nuh-yuh" },
      { english: "beach", sinhala: "වෙරළ", pronunciation: "veh-ruh-luh" },
      { english: "island", sinhala: "දූපත", pronunciation: "doo-puh-thuh" },
    ]
  },
  places: {
    name: "Places",
    nameSi: "ස්ථාන",
    icon: "🏛️",
    color: "#607D8B",
    words: [
      { english: "home", sinhala: "ගෙදර", pronunciation: "geh-duh-ruh" },
      { english: "school", sinhala: "පාසල", pronunciation: "paa-suh-luh" },
      { english: "hospital", sinhala: "රෝහල", pronunciation: "roh-huh-luh" },
      { english: "market", sinhala: "වෙළඳ පොළ", pronunciation: "veh-luhn-duh poh-luh" },
      { english: "temple", sinhala: "පන්සල", pronunciation: "puhn-suh-luh" },
      { english: "bank", sinhala: "බැංකුව", pronunciation: "behn-koo-vuh" },
      { english: "hotel", sinhala: "හෝටලය", pronunciation: "hoh-tuh-luh-yuh" },
      { english: "restaurant", sinhala: "ආපනශාලාව", pronunciation: "aa-puh-nuh-shaa-laa-vuh" },
      { english: "airport", sinhala: "ගුවන් තොටුපළ", pronunciation: "goo-vuhn thoh-too-puh-luh" },
      { english: "city", sinhala: "නගරය", pronunciation: "nuh-guh-ruh-yuh" },
      { english: "village", sinhala: "ගම", pronunciation: "guh-muh" },
      { english: "park", sinhala: "උද්‍යානය", pronunciation: "ood-yaa-nuh-yuh" },
      { english: "library", sinhala: "පුස්තකාලය", pronunciation: "poos-thuh-kaa-luh-yuh" },
      { english: "office", sinhala: "කාර්යාලය", pronunciation: "kaar-yaa-luh-yuh" },
    ]
  },
  transport: {
    name: "Transport",
    nameSi: "ප්‍රවාහන",
    icon: "🚗",
    color: "#00BCD4",
    words: [
      { english: "car", sinhala: "මෝටර් රථය", pronunciation: "moh-tuhr ruh-thuh-yuh" },
      { english: "bus", sinhala: "බස් රථය", pronunciation: "buhs ruh-thuh-yuh" },
      { english: "train", sinhala: "දුම්රිය", pronunciation: "doom-ree-yuh" },
      { english: "bicycle", sinhala: "බයිසිකලය", pronunciation: "bai-see-kuh-luh-yuh" },
      { english: "motorcycle", sinhala: "යතුරුපැදිය", pronunciation: "yuh-thoo-roo-peh-dee-yuh" },
      { english: "airplane", sinhala: "ගුවන් යානය", pronunciation: "goo-vuhn yaa-nuh-yuh" },
      { english: "boat", sinhala: "බෝට්ටුව", pronunciation: "boht-too-vuh" },
      { english: "ship", sinhala: "නැව", pronunciation: "neh-vuh" },
      { english: "tuk-tuk", sinhala: "ත්‍රිරෝද රථය", pronunciation: "three-roh-duh ruh-thuh-yuh" },
      { english: "taxi", sinhala: "ටැක්සිය", pronunciation: "tehk-see-yuh" },
      { english: "truck", sinhala: "ලොරිය", pronunciation: "loh-ree-yuh" },
      { english: "helicopter", sinhala: "හෙලිකොප්ටරය", pronunciation: "heh-lee-kohp-tuh-ruh-yuh" },
    ]
  },
  professions: {
    name: "Professions",
    nameSi: "වෘත්තීන්",
    icon: "👨‍💼",
    color: "#3F51B5",
    words: [
      { english: "teacher", sinhala: "ගුරුවරයා", pronunciation: "goo-roo-vuh-ruh-yaa" },
      { english: "doctor", sinhala: "වෛද්‍යවරයා", pronunciation: "vaid-yuh-vuh-ruh-yaa" },
      { english: "nurse", sinhala: "හෙදිය", pronunciation: "heh-dee-yuh" },
      { english: "police", sinhala: "පොලිසිය", pronunciation: "poh-lee-see-yuh" },
      { english: "farmer", sinhala: "ගොවියා", pronunciation: "goh-vee-yaa" },
      { english: "driver", sinhala: "රියදුරා", pronunciation: "ree-yuh-doo-raa" },
      { english: "engineer", sinhala: "ඉංජිනේරු", pronunciation: "in-jee-nay-roo" },
      { english: "lawyer", sinhala: "නීතිඥයා", pronunciation: "nee-theeg-nuh-yaa" },
      { english: "singer", sinhala: "ගායකයා", pronunciation: "gaa-yuh-kuh-yaa" },
      { english: "dancer", sinhala: "නර්තකයා", pronunciation: "nuhr-thuh-kuh-yaa" },
      { english: "chef", sinhala: "පිසින්නා", pronunciation: "pee-sin-naa" },
      { english: "pilot", sinhala: "ගුවන් නියමුවා", pronunciation: "goo-vuhn nee-yuh-moo-vaa" },
      { english: "fisherman", sinhala: "ධීවරයා", pronunciation: "dhee-vuh-ruh-yaa" },
      { english: "artist", sinhala: "කලාකරුවා", pronunciation: "kuh-laa-kuh-roo-vaa" },
    ]
  },
  time: {
    name: "Time & Days",
    nameSi: "කාලය සහ දින",
    icon: "⏰",
    color: "#FF5722",
    words: [
      { english: "today", sinhala: "අද", pronunciation: "uh-duh" },
      { english: "tomorrow", sinhala: "හෙට", pronunciation: "heh-tuh" },
      { english: "yesterday", sinhala: "ඊයේ", pronunciation: "ee-yay" },
      { english: "morning", sinhala: "උදේ", pronunciation: "oo-day" },
      { english: "afternoon", sinhala: "දවල්", pronunciation: "duh-vuhl" },
      { english: "evening", sinhala: "සවස", pronunciation: "suh-vuh-suh" },
      { english: "night", sinhala: "රාත්‍රිය", pronunciation: "raa-three-yuh" },
      { english: "monday", sinhala: "සඳුදා", pronunciation: "suhn-doo-daa" },
      { english: "tuesday", sinhala: "අඟහරුවාදා", pronunciation: "uhn-guh-huh-roo-vaa-daa" },
      { english: "wednesday", sinhala: "බදාදා", pronunciation: "buh-daa-daa" },
      { english: "thursday", sinhala: "බ්‍රහස්පතින්දා", pronunciation: "bruh-huhs-puh-thin-daa" },
      { english: "friday", sinhala: "සිකුරාදා", pronunciation: "see-koo-raa-daa" },
      { english: "saturday", sinhala: "සෙනසුරාදා", pronunciation: "seh-nuh-soo-raa-daa" },
      { english: "sunday", sinhala: "ඉරිදා", pronunciation: "ee-ree-daa" },
    ]
  },
  weather: {
    name: "Weather",
    nameSi: "කාලගුණය",
    icon: "🌤️",
    color: "#03A9F4",
    words: [
      { english: "hot", sinhala: "උණුසුම්", pronunciation: "oo-noo-soom" },
      { english: "cold", sinhala: "සීතල", pronunciation: "see-thuh-luh" },
      { english: "rain", sinhala: "වැස්ස", pronunciation: "vehs-suh" },
      { english: "sunny", sinhala: "අව්ව", pronunciation: "uhv-vuh" },
      { english: "cloudy", sinhala: "වලාකුළු", pronunciation: "vuh-laa-koo-loo" },
      { english: "windy", sinhala: "සුළං", pronunciation: "soo-luhn" },
      { english: "storm", sinhala: "කුණාටුව", pronunciation: "koo-naa-too-vuh" },
      { english: "thunder", sinhala: "ගිගුරුම", pronunciation: "gee-goo-roo-muh" },
      { english: "lightning", sinhala: "අකුණ", pronunciation: "uh-koo-nuh" },
      { english: "fog", sinhala: "මීදුම", pronunciation: "mee-doo-muh" },
      { english: "snow", sinhala: "හිම", pronunciation: "hee-muh" },
    ]
  },
  technology: {
    name: "Technology",
    nameSi: "තාක්ෂණය",
    icon: "💻",
    color: "#673AB7",
    words: [
      { english: "computer", sinhala: "පරිගණකය", pronunciation: "puh-ree-guh-nuh-kuh-yuh" },
      { english: "phone", sinhala: "දුරකථනය", pronunciation: "doo-ruh-kuh-thuh-nuh-yuh" },
      { english: "television", sinhala: "රූපවාහිනිය", pronunciation: "roo-puh-vaa-hee-nee-yuh" },
      { english: "internet", sinhala: "අන්තර්ජාලය", pronunciation: "uhn-thuhr-jaa-luh-yuh" },
      { english: "email", sinhala: "විද්‍යුත් තැපෑල", pronunciation: "vid-yooth theh-peh-luh" },
      { english: "camera", sinhala: "කැමරාව", pronunciation: "keh-muh-raa-vuh" },
      { english: "laptop", sinhala: "ලැප්ටොප්", pronunciation: "lehp-tohp" },
      { english: "keyboard", sinhala: "යතුරු පුවරුව", pronunciation: "yuh-thoo-roo poo-vuh-roo-vuh" },
      { english: "mouse", sinhala: "මවුසය", pronunciation: "mau-suh-yuh" },
      { english: "printer", sinhala: "මුද්‍රණ යන්ත්‍රය", pronunciation: "mood-ruh-nuh yuhn-thruh-yuh" },
      { english: "radio", sinhala: "ගුවන් විදුලිය", pronunciation: "goo-vuhn vee-doo-lee-yuh" },
    ]
  },
  household: {
    name: "Household",
    nameSi: "ගෘහ භාණ්ඩ",
    icon: "🏠",
    color: "#8BC34A",
    words: [
      { english: "table", sinhala: "මේසය", pronunciation: "may-suh-yuh" },
      { english: "chair", sinhala: "පුටුව", pronunciation: "poo-too-vuh" },
      { english: "bed", sinhala: "ඇඳ", pronunciation: "ehn-duh" },
      { english: "door", sinhala: "දොර", pronunciation: "doh-ruh" },
      { english: "window", sinhala: "ජනේලය", pronunciation: "juh-nay-luh-yuh" },
      { english: "lamp", sinhala: "ලාම්පුව", pronunciation: "laam-poo-vuh" },
      { english: "fan", sinhala: "පංකාව", pronunciation: "puhn-kaa-vuh" },
      { english: "mirror", sinhala: "කණ්ණාඩිය", pronunciation: "kuhn-naa-dee-yuh" },
      { english: "clock", sinhala: "ඔරලෝසුව", pronunciation: "oh-ruh-loh-soo-vuh" },
      { english: "pillow", sinhala: "කොට්ටය", pronunciation: "koht-tuh-yuh" },
      { english: "blanket", sinhala: "බ්ලැන්කට්", pronunciation: "blehn-kuht" },
      { english: "towel", sinhala: "තුවාය", pronunciation: "thoo-vaa-yuh" },
      { english: "soap", sinhala: "සබන්", pronunciation: "suh-buhn" },
      { english: "knife", sinhala: "පිහිය", pronunciation: "pee-hee-yuh" },
      { english: "spoon", sinhala: "හැන්ද", pronunciation: "hehn-duh" },
      { english: "plate", sinhala: "පිඟානය", pronunciation: "pin-gaa-nuh-yuh" },
      { english: "cup", sinhala: "කෝප්පය", pronunciation: "kohp-puh-yuh" },
    ]
  },
  clothing: {
    name: "Clothing",
    nameSi: "ඇඳුම්",
    icon: "👔",
    color: "#E91E63",
    words: [
      { english: "shirt", sinhala: "කමිසය", pronunciation: "kuh-mee-suh-yuh" },
      { english: "pants", sinhala: "කලිසම", pronunciation: "kuh-lee-suh-muh" },
      { english: "dress", sinhala: "ගවුම", pronunciation: "guh-voo-muh" },
      { english: "shoes", sinhala: "සපත්තු", pronunciation: "suh-puhth-thoo" },
      { english: "hat", sinhala: "තොප්පිය", pronunciation: "thohp-pee-yuh" },
      { english: "jacket", sinhala: "ජැකට්", pronunciation: "jeh-kuht" },
      { english: "jeans", sinhala: "ජීන්ස්", pronunciation: "jeens" },
      { english: "skirt", sinhala: "සාය", pronunciation: "saa-yuh" },
      { english: "socks", sinhala: "මේස්", pronunciation: "mays" },
      { english: "tie", sinhala: "ටයි", pronunciation: "tai" },
      { english: "belt", sinhala: "පටිය", pronunciation: "puh-tee-yuh" },
      { english: "glasses", sinhala: "කණ්ණාඩි", pronunciation: "kuhn-naa-dee" },
      { english: "watch", sinhala: "ඔරලෝසුව", pronunciation: "oh-ruh-loh-soo-vuh" },
      { english: "umbrella", sinhala: "කුඩය", pronunciation: "koo-duh-yuh" },
    ]
  },
  verbs: {
    name: "Common Verbs",
    nameSi: "ක්‍රියා පද",
    icon: "🏃",
    color: "#009688",
    words: [
      { english: "eat", sinhala: "කනවා", pronunciation: "kuh-nuh-vaa" },
      { english: "drink", sinhala: "බොනවා", pronunciation: "boh-nuh-vaa" },
      { english: "sleep", sinhala: "නිදාගන්නවා", pronunciation: "nee-daa-guhn-nuh-vaa" },
      { english: "walk", sinhala: "යනවා", pronunciation: "yuh-nuh-vaa" },
      { english: "run", sinhala: "දුවනවා", pronunciation: "doo-vuh-nuh-vaa" },
      { english: "read", sinhala: "කියවනවා", pronunciation: "kee-yuh-vuh-nuh-vaa" },
      { english: "write", sinhala: "ලියනවා", pronunciation: "lee-yuh-nuh-vaa" },
      { english: "speak", sinhala: "කතා කරනවා", pronunciation: "kuh-thaa kuh-ruh-nuh-vaa" },
      { english: "listen", sinhala: "අහනවා", pronunciation: "uh-huh-nuh-vaa" },
      { english: "see", sinhala: "බලනවා", pronunciation: "buh-luh-nuh-vaa" },
      { english: "come", sinhala: "එනවා", pronunciation: "eh-nuh-vaa" },
      { english: "go", sinhala: "යනවා", pronunciation: "yuh-nuh-vaa" },
      { english: "sit", sinhala: "වාඩි වෙනවා", pronunciation: "vaa-dee veh-nuh-vaa" },
      { english: "stand", sinhala: "නැගිටිනවා", pronunciation: "neh-gee-tee-nuh-vaa" },
      { english: "love", sinhala: "ආදරය කරනවා", pronunciation: "aa-duh-ruh-yuh kuh-ruh-nuh-vaa" },
      { english: "think", sinhala: "හිතනවා", pronunciation: "hee-thuh-nuh-vaa" },
      { english: "know", sinhala: "දන්නවා", pronunciation: "duhn-nuh-vaa" },
      { english: "give", sinhala: "දෙනවා", pronunciation: "deh-nuh-vaa" },
      { english: "take", sinhala: "ගන්නවා", pronunciation: "guhn-nuh-vaa" },
    ]
  },
  adjectives: {
    name: "Adjectives",
    nameSi: "විශේෂණ",
    icon: "✨",
    color: "#FFC107",
    words: [
      { english: "big", sinhala: "ලොකු", pronunciation: "loh-koo" },
      { english: "small", sinhala: "පොඩි", pronunciation: "poh-dee" },
      { english: "good", sinhala: "හොඳ", pronunciation: "hohn-duh" },
      { english: "bad", sinhala: "නරක", pronunciation: "nuh-ruh-kuh" },
      { english: "beautiful", sinhala: "ලස්සන", pronunciation: "luhs-suh-nuh" },
      { english: "happy", sinhala: "සතුටු", pronunciation: "suh-thoo-too" },
      { english: "sad", sinhala: "දුකට", pronunciation: "doo-kuh-tuh" },
      { english: "new", sinhala: "අලුත්", pronunciation: "uh-looth" },
      { english: "old", sinhala: "පරණ", pronunciation: "puh-ruh-nuh" },
      { english: "fast", sinhala: "වේගවත්", pronunciation: "vay-guh-vuhth" },
      { english: "slow", sinhala: "සෙමින්", pronunciation: "seh-min" },
      { english: "hot", sinhala: "උණුසුම්", pronunciation: "oo-noo-soom" },
      { english: "cold", sinhala: "සීතල", pronunciation: "see-thuh-luh" },
      { english: "tall", sinhala: "උස", pronunciation: "oo-suh" },
      { english: "short", sinhala: "මිටි", pronunciation: "mee-tee" },
      { english: "strong", sinhala: "ශක්තිමත්", pronunciation: "shuhk-thee-muhth" },
      { english: "kind", sinhala: "කරුණාවන්ත", pronunciation: "kuh-roo-naa-vuhn-thuh" },
    ]
  },
  emotions: {
    name: "Emotions",
    nameSi: "හැඟීම්",
    icon: "😊",
    color: "#FF4081",
    words: [
      { english: "happy", sinhala: "සතුටු", pronunciation: "suh-thoo-too" },
      { english: "sad", sinhala: "දුකට", pronunciation: "doo-kuh-tuh" },
      { english: "angry", sinhala: "තරහ", pronunciation: "thuh-ruh-huh" },
      { english: "afraid", sinhala: "බය", pronunciation: "buh-yuh" },
      { english: "surprised", sinhala: "පුදුම", pronunciation: "poo-doo-muh" },
      { english: "tired", sinhala: "වෙහෙසුණු", pronunciation: "veh-heh-soo-noo" },
      { english: "hungry", sinhala: "බඩගිනි", pronunciation: "buh-duh-gee-nee" },
      { english: "thirsty", sinhala: "පිපාසය", pronunciation: "pee-paa-suh-yuh" },
      { english: "excited", sinhala: "උද්යෝගිමත්", pronunciation: "ood-yoh-gee-muhth" },
      { english: "bored", sinhala: "කම්මැලි", pronunciation: "kuhm-meh-lee" },
      { english: "proud", sinhala: "ආඩම්බර", pronunciation: "aa-duhm-buh-ruh" },
      { english: "shy", sinhala: "ලැජ්ජා", pronunciation: "lehj-jaa" },
      { english: "love", sinhala: "ආදරය", pronunciation: "aa-duh-ruh-yuh" },
      { english: "peace", sinhala: "සාමය", pronunciation: "saa-muh-yuh" },
      { english: "hope", sinhala: "බලාපොරොත්තුව", pronunciation: "buh-laa-poh-rohth-thoo-vuh" },
    ]
  },
  sports: {
    name: "Sports & Games",
    nameSi: "ක්‍රීඩා",
    icon: "⚽",
    color: "#4CAF50",
    words: [
      { english: "football", sinhala: "පාපන්දු", pronunciation: "paa-puhn-doo" },
      { english: "cricket", sinhala: "ක්‍රිකට්", pronunciation: "kree-kuht" },
      { english: "basketball", sinhala: "පැසිපන්දු", pronunciation: "peh-see-puhn-doo" },
      { english: "tennis", sinhala: "ටෙනිස්", pronunciation: "teh-nis" },
      { english: "volleyball", sinhala: "වොලිබෝල්", pronunciation: "voh-lee-bohl" },
      { english: "swimming", sinhala: "පිහිනීම", pronunciation: "pee-hee-nee-muh" },
      { english: "running", sinhala: "දිවීම", pronunciation: "dee-vee-muh" },
      { english: "cycling", sinhala: "බයිසිකල් පැදීම", pronunciation: "bai-see-kuhl peh-dee-muh" },
      { english: "boxing", sinhala: "මුෂ්ටි සටන", pronunciation: "moosh-tee suh-tuh-nuh" },
      { english: "wrestling", sinhala: "මල්ලව පොර", pronunciation: "muhl-luh-vuh poh-ruh" },
      { english: "badminton", sinhala: "බැඩ්මින්ටන්", pronunciation: "behd-min-tuhn" },
      { english: "golf", sinhala: "ගොල්ෆ්", pronunciation: "gohlf" },
      { english: "hockey", sinhala: "හොකී", pronunciation: "hoh-kee" },
      { english: "chess", sinhala: "චෙස්", pronunciation: "chehs" },
      { english: "game", sinhala: "ක්‍රීඩාව", pronunciation: "kree-daa-vuh" },
      { english: "ball", sinhala: "පන්දුව", pronunciation: "puhn-doo-vuh" },
      { english: "team", sinhala: "කණ්ඩායම", pronunciation: "kuhn-daa-yuh-muh" },
      { english: "player", sinhala: "ක්‍රීඩකයා", pronunciation: "kree-duh-kuh-yaa" },
      { english: "winner", sinhala: "ජයග්‍රාහකයා", pronunciation: "juh-yuh-graa-huh-kuh-yaa" },
      { english: "score", sinhala: "ලකුණු", pronunciation: "luh-koo-noo" },
    ]
  },
  education: {
    name: "Education",
    nameSi: "අධ්‍යාපනය",
    icon: "📖",
    color: "#9C27B0",
    words: [
      { english: "school", sinhala: "පාසල", pronunciation: "paa-suh-luh" },
      { english: "teacher", sinhala: "ගුරුවරයා", pronunciation: "goo-roo-vuh-ruh-yaa" },
      { english: "student", sinhala: "සිසුවා", pronunciation: "see-soo-vaa" },
      { english: "book", sinhala: "පොත", pronunciation: "poh-thuh" },
      { english: "pen", sinhala: "පෑන", pronunciation: "peh-nuh" },
      { english: "pencil", sinhala: "පැන්සල", pronunciation: "pehn-suh-luh" },
      { english: "notebook", sinhala: "සටහන් පොත", pronunciation: "suh-tuh-huhn poh-thuh" },
      { english: "eraser", sinhala: "මකනය", pronunciation: "muh-kuh-nuh-yuh" },
      { english: "ruler", sinhala: "රූලරය", pronunciation: "roo-luh-ruh-yuh" },
      { english: "classroom", sinhala: "පන්ති කාමරය", pronunciation: "puhn-thee kaa-muh-ruh-yuh" },
      { english: "lesson", sinhala: "පාඩම", pronunciation: "paa-duh-muh" },
      { english: "homework", sinhala: "ගෙදර වැඩ", pronunciation: "geh-duh-ruh veh-duh" },
      { english: "exam", sinhala: "විභාගය", pronunciation: "vee-bhaa-guh-yuh" },
      { english: "test", sinhala: "පරීක්ෂණය", pronunciation: "puh-reek-shuh-nuh-yuh" },
      { english: "university", sinhala: "විශ්වවිද්‍යාලය", pronunciation: "vish-vuh-vid-yaa-luh-yuh" },
      { english: "library", sinhala: "පුස්තකාලය", pronunciation: "poos-thuh-kaa-luh-yuh" },
      { english: "dictionary", sinhala: "ශබ්දකෝෂය", pronunciation: "shuhb-duh-koh-shuh-yuh" },
      { english: "degree", sinhala: "උපාධිය", pronunciation: "oo-paa-dhee-yuh" },
    ]
  },
  music: {
    name: "Music & Arts",
    nameSi: "සංගීතය සහ කලාව",
    icon: "🎵",
    color: "#E91E63",
    words: [
      { english: "music", sinhala: "සංගීතය", pronunciation: "suhn-gee-thuh-yuh" },
      { english: "song", sinhala: "ගීතය", pronunciation: "gee-thuh-yuh" },
      { english: "singer", sinhala: "ගායකයා", pronunciation: "gaa-yuh-kuh-yaa" },
      { english: "dance", sinhala: "නැටුම", pronunciation: "neh-too-muh" },
      { english: "dancer", sinhala: "නර්තකයා", pronunciation: "nuhr-thuh-kuh-yaa" },
      { english: "drum", sinhala: "බෙරය", pronunciation: "beh-ruh-yuh" },
      { english: "guitar", sinhala: "ගිටාරය", pronunciation: "gee-taa-ruh-yuh" },
      { english: "piano", sinhala: "පියානෝව", pronunciation: "pee-yaa-noh-vuh" },
      { english: "flute", sinhala: "නලාව", pronunciation: "nuh-laa-vuh" },
      { english: "violin", sinhala: "වයලීනය", pronunciation: "vuh-yuh-lee-nuh-yuh" },
      { english: "painting", sinhala: "චිත්‍රය", pronunciation: "chith-ruh-yuh" },
      { english: "drawing", sinhala: "ඇඳීම", pronunciation: "ehn-dee-muh" },
      { english: "art", sinhala: "කලාව", pronunciation: "kuh-laa-vuh" },
      { english: "artist", sinhala: "කලාකරුවා", pronunciation: "kuh-laa-kuh-roo-vaa" },
      { english: "theater", sinhala: "රංග ශාලාව", pronunciation: "ruhn-guh shaa-laa-vuh" },
      { english: "movie", sinhala: "චිත්‍රපටය", pronunciation: "chith-ruh-puh-tuh-yuh" },
      { english: "actor", sinhala: "නළුවා", pronunciation: "nuh-loo-vaa" },
      { english: "actress", sinhala: "නිළිය", pronunciation: "nee-lee-yuh" },
    ]
  },
  health: {
    name: "Health & Medicine",
    nameSi: "සෞඛ්‍යය සහ වෛද්‍ය",
    icon: "🏥",
    color: "#F44336",
    words: [
      { english: "doctor", sinhala: "වෛද්‍යවරයා", pronunciation: "vaid-yuh-vuh-ruh-yaa" },
      { english: "nurse", sinhala: "හෙදිය", pronunciation: "heh-dee-yuh" },
      { english: "hospital", sinhala: "රෝහල", pronunciation: "roh-huh-luh" },
      { english: "medicine", sinhala: "බෙහෙත්", pronunciation: "beh-hehth" },
      { english: "sick", sinhala: "අසනීප", pronunciation: "uh-suh-nee-puh" },
      { english: "healthy", sinhala: "සෞඛ්‍ය සම්පන්න", pronunciation: "sau-khyuh suhm-puhn-nuh" },
      { english: "pain", sinhala: "වේදනාව", pronunciation: "vay-duh-naa-vuh" },
      { english: "headache", sinhala: "හිසරදය", pronunciation: "hee-suh-ruh-duh-yuh" },
      { english: "fever", sinhala: "උණ", pronunciation: "oo-nuh" },
      { english: "cold", sinhala: "සෙම්ප්‍රතිශ්‍යාව", pronunciation: "sehm-pruh-theesh-yaa-vuh" },
      { english: "cough", sinhala: "කැස්ස", pronunciation: "kehs-suh" },
      { english: "injection", sinhala: "එන්නත", pronunciation: "ehn-nuh-thuh" },
      { english: "pharmacy", sinhala: "ඖෂධ ශාලාව", pronunciation: "au-shuh-dhuh shaa-laa-vuh" },
      { english: "dentist", sinhala: "දන්ත වෛද්‍යවරයා", pronunciation: "duhn-thuh vaid-yuh-vuh-ruh-yaa" },
      { english: "blood", sinhala: "ලේ", pronunciation: "lay" },
      { english: "heart", sinhala: "හදවත", pronunciation: "huh-duh-vuh-thuh" },
    ]
  },
  shopping: {
    name: "Shopping & Money",
    nameSi: "සාප්පු සවාරි",
    icon: "🛒",
    color: "#FF9800",
    words: [
      { english: "shop", sinhala: "කඩය", pronunciation: "kuh-duh-yuh" },
      { english: "market", sinhala: "වෙළඳ පොළ", pronunciation: "veh-luhn-duh poh-luh" },
      { english: "money", sinhala: "මුදල්", pronunciation: "moo-duhl" },
      { english: "price", sinhala: "මිල", pronunciation: "mee-luh" },
      { english: "cheap", sinhala: "ලාභ", pronunciation: "laa-bhuh" },
      { english: "expensive", sinhala: "මිල අධික", pronunciation: "mee-luh uh-dhee-kuh" },
      { english: "buy", sinhala: "ගන්නවා", pronunciation: "guhn-nuh-vaa" },
      { english: "sell", sinhala: "විකුණනවා", pronunciation: "vee-koo-nuh-nuh-vaa" },
      { english: "pay", sinhala: "ගෙවනවා", pronunciation: "geh-vuh-nuh-vaa" },
      { english: "cash", sinhala: "මුදල්", pronunciation: "moo-duhl" },
      { english: "card", sinhala: "කාඩ්පත", pronunciation: "kaad-puh-thuh" },
      { english: "receipt", sinhala: "රිසිට්පත", pronunciation: "ree-sit-puh-thuh" },
      { english: "discount", sinhala: "වට්ටම", pronunciation: "vuht-tuh-muh" },
      { english: "customer", sinhala: "පාරිභෝගිකයා", pronunciation: "paa-ree-bhoh-gee-kuh-yaa" },
      { english: "seller", sinhala: "විකුණුම්කරු", pronunciation: "vee-koo-noom-kuh-roo" },
      { english: "bag", sinhala: "බෑගය", pronunciation: "beh-guh-yuh" },
    ]
  },
  fruits: {
    name: "Fruits",
    nameSi: "පලතුරු",
    icon: "🍎",
    color: "#E53935",
    words: [
      { english: "apple", sinhala: "ඇපල්", pronunciation: "eh-puhl" },
      { english: "banana", sinhala: "කෙසෙල්", pronunciation: "keh-sehl" },
      { english: "mango", sinhala: "අඹ", pronunciation: "uhm-buh" },
      { english: "orange", sinhala: "දොඩම්", pronunciation: "doh-duhm" },
      { english: "grapes", sinhala: "මිදි", pronunciation: "mee-dee" },
      { english: "pineapple", sinhala: "අන්නාසි", pronunciation: "uhn-naa-see" },
      { english: "papaya", sinhala: "පැපොල්", pronunciation: "peh-pohl" },
      { english: "watermelon", sinhala: "කොමඩු", pronunciation: "koh-muh-doo" },
      { english: "coconut", sinhala: "පොල්", pronunciation: "pohl" },
      { english: "guava", sinhala: "පේර", pronunciation: "pay-ruh" },
      { english: "lemon", sinhala: "දෙහි", pronunciation: "deh-hee" },
      { english: "lime", sinhala: "දෙහි", pronunciation: "deh-hee" },
      { english: "jackfruit", sinhala: "කොස්", pronunciation: "kohs" },
      { english: "durian", sinhala: "දූරියන්", pronunciation: "doo-ree-yuhn" },
      { english: "avocado", sinhala: "අලිගැට පේර", pronunciation: "uh-lee-geh-tuh pay-ruh" },
      { english: "strawberry", sinhala: "ස්ට්‍රෝබෙරි", pronunciation: "stroh-beh-ree" },
    ]
  },
  vegetables: {
    name: "Vegetables",
    nameSi: "එළවළු",
    icon: "🥕",
    color: "#43A047",
    words: [
      { english: "carrot", sinhala: "කැරට්", pronunciation: "keh-ruht" },
      { english: "potato", sinhala: "අල", pronunciation: "uh-luh" },
      { english: "tomato", sinhala: "තක්කාලි", pronunciation: "thuhk-kaa-lee" },
      { english: "onion", sinhala: "ලූණු", pronunciation: "loo-noo" },
      { english: "garlic", sinhala: "සුදු ලූණු", pronunciation: "soo-doo loo-noo" },
      { english: "cabbage", sinhala: "ගෝවා", pronunciation: "goh-vaa" },
      { english: "beans", sinhala: "බෝංචි", pronunciation: "bohn-chee" },
      { english: "pumpkin", sinhala: "වට්ටක්කා", pronunciation: "vuht-tuhk-kaa" },
      { english: "cucumber", sinhala: "පිපිඤ්ඤා", pronunciation: "pee-pin-yaa" },
      { english: "eggplant", sinhala: "වම්බටු", pronunciation: "vuhm-buh-too" },
      { english: "spinach", sinhala: "නිවිති", pronunciation: "nee-vee-thee" },
      { english: "corn", sinhala: "බඩ ඉරිඟු", pronunciation: "buh-duh ee-rin-goo" },
      { english: "pepper", sinhala: "ගම්මිරිස්", pronunciation: "guhm-mee-ris" },
      { english: "chili", sinhala: "මිරිස්", pronunciation: "mee-ris" },
      { english: "ginger", sinhala: "ඉඟුරු", pronunciation: "in-goo-roo" },
      { english: "mushroom", sinhala: "බිම්මල්", pronunciation: "bim-muhl" },
    ]
  },
  religion: {
    name: "Religion & Culture",
    nameSi: "ආගම සහ සංස්කෘතිය",
    icon: "🙏",
    color: "#FF6F00",
    words: [
      { english: "temple", sinhala: "පන්සල", pronunciation: "puhn-suh-luh" },
      { english: "church", sinhala: "පල්ලිය", pronunciation: "puhl-lee-yuh" },
      { english: "mosque", sinhala: "මුස්ලිම් පල්ලිය", pronunciation: "mus-lim puhl-lee-yuh" },
      { english: "kovil", sinhala: "කෝවිල", pronunciation: "koh-vee-luh" },
      { english: "buddha", sinhala: "බුදුන් වහන්සේ", pronunciation: "boo-doon vuh-huhn-say" },
      { english: "monk", sinhala: "භික්ෂුව", pronunciation: "bhik-shoo-vuh" },
      { english: "prayer", sinhala: "යාඥාව", pronunciation: "yaag-naa-vuh" },
      { english: "blessing", sinhala: "ආශිර්වාදය", pronunciation: "aa-shir-vaa-duh-yuh" },
      { english: "festival", sinhala: "උත්සවය", pronunciation: "ooth-suh-vuh-yuh" },
      { english: "vesak", sinhala: "වෙසක්", pronunciation: "veh-suhk" },
      { english: "poson", sinhala: "පොසොන්", pronunciation: "poh-sohn" },
      { english: "new year", sinhala: "අලුත් අවුරුද්ද", pronunciation: "uh-looth uh-voo-rood-duh" },
      { english: "tradition", sinhala: "සම්ප්‍රදාය", pronunciation: "suhm-pruh-daa-yuh" },
      { english: "culture", sinhala: "සංස්කෘතිය", pronunciation: "suhn-skru-thee-yuh" },
      { english: "ceremony", sinhala: "උත්සවය", pronunciation: "ooth-suh-vuh-yuh" },
    ]
  },
  directions: {
    name: "Directions",
    nameSi: "දිශාවන්",
    icon: "🧭",
    color: "#1976D2",
    words: [
      { english: "left", sinhala: "වම", pronunciation: "vuh-muh" },
      { english: "right", sinhala: "දකුණ", pronunciation: "duh-koo-nuh" },
      { english: "straight", sinhala: "කෙලින්ම", pronunciation: "keh-lin-muh" },
      { english: "up", sinhala: "ඉහළට", pronunciation: "ee-huh-luh-tuh" },
      { english: "down", sinhala: "පහළට", pronunciation: "puh-huh-luh-tuh" },
      { english: "front", sinhala: "ඉදිරිය", pronunciation: "ee-dee-ree-yuh" },
      { english: "back", sinhala: "පිටුපස", pronunciation: "pee-too-puh-suh" },
      { english: "north", sinhala: "උතුර", pronunciation: "oo-thoo-ruh" },
      { english: "south", sinhala: "දකුණ", pronunciation: "duh-koo-nuh" },
      { english: "east", sinhala: "නැගෙනහිර", pronunciation: "neh-geh-nuh-hee-ruh" },
      { english: "west", sinhala: "බටහිර", pronunciation: "buh-tuh-hee-ruh" },
      { english: "near", sinhala: "ළඟ", pronunciation: "luh-nguh" },
      { english: "far", sinhala: "දුර", pronunciation: "doo-ruh" },
      { english: "here", sinhala: "මෙතන", pronunciation: "meh-thuh-nuh" },
      { english: "there", sinhala: "එතන", pronunciation: "eh-thuh-nuh" },
      { english: "where", sinhala: "කොහේද", pronunciation: "koh-hay-duh" },
    ]
  },
  insects: {
    name: "Insects & Bugs",
    nameSi: "කෘමීන්",
    icon: "🦋",
    color: "#8BC34A",
    words: [
      { english: "butterfly", sinhala: "සමනලයා", pronunciation: "suh-muh-nuh-luh-yaa" },
      { english: "bee", sinhala: "මීමැස්සා", pronunciation: "mee-mehs-saa" },
      { english: "ant", sinhala: "කුහුඹුවා", pronunciation: "koo-hoom-boo-vaa" },
      { english: "mosquito", sinhala: "මදුරුවා", pronunciation: "muh-doo-roo-vaa" },
      { english: "fly", sinhala: "මැස්සා", pronunciation: "mehs-saa" },
      { english: "spider", sinhala: "මකුළුවා", pronunciation: "muh-koo-loo-vaa" },
      { english: "cockroach", sinhala: "කැරපොත්තා", pronunciation: "keh-ruh-pohth-thaa" },
      { english: "grasshopper", sinhala: "තෘණ පනුවා", pronunciation: "thru-nuh puh-noo-vaa" },
      { english: "dragonfly", sinhala: "කටුස්සා", pronunciation: "kuh-toos-saa" },
      { english: "beetle", sinhala: "කුරුමිණියා", pronunciation: "koo-roo-mee-nee-yaa" },
      { english: "worm", sinhala: "පණුවා", pronunciation: "puh-noo-vaa" },
      { english: "caterpillar", sinhala: "දළඹුවා", pronunciation: "duh-luhm-boo-vaa" },
      { english: "firefly", sinhala: "කදුලැස්සා", pronunciation: "kuh-doo-lehs-saa" },
      { english: "ladybug", sinhala: "ලේඩිබග්", pronunciation: "lay-dee-buhg" },
    ]
  },
  sea: {
    name: "Sea & Ocean",
    nameSi: "මුහුද",
    icon: "🌊",
    color: "#0288D1",
    words: [
      { english: "sea", sinhala: "මුහුද", pronunciation: "moo-hoo-duh" },
      { english: "ocean", sinhala: "සාගරය", pronunciation: "saa-guh-ruh-yuh" },
      { english: "beach", sinhala: "වෙරළ", pronunciation: "veh-ruh-luh" },
      { english: "wave", sinhala: "රළ", pronunciation: "ruh-luh" },
      { english: "sand", sinhala: "වැලි", pronunciation: "veh-lee" },
      { english: "fish", sinhala: "මාළුවා", pronunciation: "maa-loo-vaa" },
      { english: "whale", sinhala: "තල්මසා", pronunciation: "thuhl-muh-saa" },
      { english: "dolphin", sinhala: "ඩොල්ෆින්", pronunciation: "dohl-fin" },
      { english: "shark", sinhala: "මෝරා", pronunciation: "moh-raa" },
      { english: "crab", sinhala: "කකුළුවා", pronunciation: "kuh-koo-loo-vaa" },
      { english: "lobster", sinhala: "ඉස්සා", pronunciation: "is-saa" },
      { english: "octopus", sinhala: "බූවල්ලා", pronunciation: "boo-vuhl-laa" },
      { english: "jellyfish", sinhala: "ලොඩි", pronunciation: "loh-dee" },
      { english: "coral", sinhala: "කොරල්", pronunciation: "koh-ruhl" },
      { english: "shell", sinhala: "බෙල්ල", pronunciation: "behl-luh" },
      { english: "boat", sinhala: "බෝට්ටුව", pronunciation: "boht-too-vuh" },
    ]
  },
  kitchen: {
    name: "Kitchen",
    nameSi: "කුස්සිය",
    icon: "🍳",
    color: "#795548",
    words: [
      { english: "kitchen", sinhala: "කුස්සිය", pronunciation: "koos-see-yuh" },
      { english: "stove", sinhala: "උදුන", pronunciation: "oo-doo-nuh" },
      { english: "oven", sinhala: "උදුන", pronunciation: "oo-doo-nuh" },
      { english: "refrigerator", sinhala: "ශීතකරණය", pronunciation: "shee-thuh-kuh-ruh-nuh-yuh" },
      { english: "pot", sinhala: "භාජනය", pronunciation: "bhaa-juh-nuh-yuh" },
      { english: "pan", sinhala: "තැටිය", pronunciation: "theh-tee-yuh" },
      { english: "knife", sinhala: "පිහිය", pronunciation: "pee-hee-yuh" },
      { english: "spoon", sinhala: "හැන්ද", pronunciation: "hehn-duh" },
      { english: "fork", sinhala: "ගෑරප්පුව", pronunciation: "geh-ruhp-poo-vuh" },
      { english: "plate", sinhala: "පිඟානය", pronunciation: "pin-gaa-nuh-yuh" },
      { english: "bowl", sinhala: "බඳුන", pronunciation: "buhn-doo-nuh" },
      { english: "cup", sinhala: "කෝප්පය", pronunciation: "kohp-puh-yuh" },
      { english: "glass", sinhala: "වීදුරුව", pronunciation: "vee-doo-roo-vuh" },
      { english: "cook", sinhala: "පිසීම", pronunciation: "pee-see-muh" },
      { english: "boil", sinhala: "උතුරනවා", pronunciation: "oo-thoo-ruh-nuh-vaa" },
      { english: "fry", sinhala: "බැදීම", pronunciation: "beh-dee-muh" },
    ]
  },
  bathroom: {
    name: "Bathroom",
    nameSi: "නාන කාමරය",
    icon: "🚿",
    color: "#00ACC1",
    words: [
      { english: "bathroom", sinhala: "නාන කාමරය", pronunciation: "naa-nuh kaa-muh-ruh-yuh" },
      { english: "toilet", sinhala: "වැසිකිළිය", pronunciation: "veh-see-kee-lee-yuh" },
      { english: "shower", sinhala: "ෂවර්", pronunciation: "shuh-vuhr" },
      { english: "bath", sinhala: "නෑම", pronunciation: "neh-muh" },
      { english: "soap", sinhala: "සබන්", pronunciation: "suh-buhn" },
      { english: "shampoo", sinhala: "ෂැම්පු", pronunciation: "shehm-poo" },
      { english: "towel", sinhala: "තුවාය", pronunciation: "thoo-vaa-yuh" },
      { english: "toothbrush", sinhala: "දත් බුරුසුව", pronunciation: "duhth boo-roo-soo-vuh" },
      { english: "toothpaste", sinhala: "දත් පේස්ට්", pronunciation: "duhth payst" },
      { english: "mirror", sinhala: "කණ්ණාඩිය", pronunciation: "kuhn-naa-dee-yuh" },
      { english: "sink", sinhala: "සින්ක්", pronunciation: "sink" },
      { english: "tap", sinhala: "කරාමය", pronunciation: "kuh-raa-muh-yuh" },
      { english: "water", sinhala: "වතුර", pronunciation: "vuh-thoo-ruh" },
      { english: "comb", sinhala: "පනාව", pronunciation: "puh-naa-vuh" },
    ]
  },
  office: {
    name: "Office & Work",
    nameSi: "කාර්යාලය",
    icon: "💼",
    color: "#546E7A",
    words: [
      { english: "office", sinhala: "කාර්යාලය", pronunciation: "kaar-yaa-luh-yuh" },
      { english: "desk", sinhala: "මේසය", pronunciation: "may-suh-yuh" },
      { english: "chair", sinhala: "පුටුව", pronunciation: "poo-too-vuh" },
      { english: "computer", sinhala: "පරිගණකය", pronunciation: "puh-ree-guh-nuh-kuh-yuh" },
      { english: "meeting", sinhala: "රැස්වීම", pronunciation: "rehs-vee-muh" },
      { english: "boss", sinhala: "ප්‍රධානියා", pronunciation: "pruh-dhaa-nee-yaa" },
      { english: "employee", sinhala: "සේවකයා", pronunciation: "say-vuh-kuh-yaa" },
      { english: "salary", sinhala: "වැටුප", pronunciation: "veh-too-puh" },
      { english: "work", sinhala: "වැඩ", pronunciation: "veh-duh" },
      { english: "job", sinhala: "රැකියාව", pronunciation: "reh-kee-yaa-vuh" },
      { english: "project", sinhala: "ව්‍යාපෘතිය", pronunciation: "vyaa-pru-thee-yuh" },
      { english: "document", sinhala: "ලේඛනය", pronunciation: "lay-khuh-nuh-yuh" },
      { english: "email", sinhala: "විද්‍යුත් තැපෑල", pronunciation: "vid-yooth theh-peh-luh" },
      { english: "phone", sinhala: "දුරකථනය", pronunciation: "doo-ruh-kuh-thuh-nuh-yuh" },
      { english: "printer", sinhala: "මුද්‍රණ යන්ත්‍රය", pronunciation: "mood-ruh-nuh yuhn-thruh-yuh" },
    ]
  },
  questions: {
    name: "Question Words",
    nameSi: "ප්‍රශ්න වචන",
    icon: "❓",
    color: "#7B1FA2",
    words: [
      { english: "what", sinhala: "මොකද", pronunciation: "moh-kuh-duh" },
      { english: "who", sinhala: "කවුද", pronunciation: "kuh-voo-duh" },
      { english: "where", sinhala: "කොහේද", pronunciation: "koh-hay-duh" },
      { english: "when", sinhala: "කවදාද", pronunciation: "kuh-vuh-daa-duh" },
      { english: "why", sinhala: "ඇයි", pronunciation: "eh-yee" },
      { english: "how", sinhala: "කොහොමද", pronunciation: "koh-hoh-muh-duh" },
      { english: "how much", sinhala: "කීයද", pronunciation: "kee-yuh-duh" },
      { english: "how many", sinhala: "කීයක්ද", pronunciation: "kee-yuhk-duh" },
      { english: "which", sinhala: "කුමක්ද", pronunciation: "koo-muhk-duh" },
      { english: "whose", sinhala: "කාගේද", pronunciation: "kaa-gay-duh" },
      { english: "can", sinhala: "පුළුවන්ද", pronunciation: "poo-loo-vuhn-duh" },
      { english: "is there", sinhala: "තියෙනවද", pronunciation: "thee-yeh-nuh-vuh-duh" },
      { english: "do you have", sinhala: "ඔබට තියෙනවද", pronunciation: "oh-buh-tuh thee-yeh-nuh-vuh-duh" },
    ]
  },
  commonPhrases: {
    name: "Common Phrases",
    nameSi: "පොදු වාක්‍ය",
    icon: "💬",
    color: "#00897B",
    words: [
      { english: "I don't understand", sinhala: "මට තේරෙන්නේ නැහැ", pronunciation: "muh-tuh thay-rehn-nay neh-heh" },
      { english: "please repeat", sinhala: "කරුණාකර නැවත කියන්න", pronunciation: "kuh-roo-naa-kuh-ruh neh-vuh-thuh kee-yuhn-nuh" },
      { english: "speak slowly", sinhala: "සෙමින් කතා කරන්න", pronunciation: "seh-min kuh-thaa kuh-ruhn-nuh" },
      { english: "I am learning", sinhala: "මම ඉගෙන ගන්නවා", pronunciation: "muh-muh ee-geh-nuh guhn-nuh-vaa" },
      { english: "what is this", sinhala: "මේක මොකද", pronunciation: "may-kuh moh-kuh-duh" },
      { english: "how are you", sinhala: "කොහොමද", pronunciation: "koh-hoh-muh-duh" },
      { english: "I am fine", sinhala: "මම හොඳින්", pronunciation: "muh-muh hohn-din" },
      { english: "nice to meet you", sinhala: "ඔබව හමුවීම සතුටක්", pronunciation: "oh-buh-vuh huh-moo-vee-muh suh-thoo-tuhk" },
      { english: "see you later", sinhala: "පසුව හමුවෙමු", pronunciation: "puh-soo-vuh huh-moo-veh-moo" },
      { english: "take care", sinhala: "ප්‍රවේසම්", pronunciation: "pruh-vay-suhm" },
      { english: "excuse me", sinhala: "සමාවන්න", pronunciation: "suh-maa-vuhn-nuh" },
      { english: "I love you", sinhala: "මම ඔයාට ආදරෙයි", pronunciation: "muh-muh oh-yaa-tuh aa-duh-reh-yee" },
      { english: "happy birthday", sinhala: "සුභ උපන්දිනයක්", pronunciation: "soo-bhuh oo-puhn-dee-nuh-yuhk" },
      { english: "congratulations", sinhala: "සුභ පැතුම්", pronunciation: "soo-bhuh peh-thoom" },
    ]
  },
};

const Dictionary = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [playingWord, setPlayingWord] = useState(null);

  const handleSpeak = async (text, index) => {
    if (playingWord === index) {
      soundService.stop();
      setPlayingWord(null);
      return;
    }

    setPlayingWord(index);
    try {
      await soundService.speakSinhalaWord(text);
    } catch (error) {
      console.error('Audio playback error:', error);
    } finally {
      setPlayingWord(null);
    }
  };

  const categoryKeys = Object.keys(categories);

  return (
    <div className="dictionary-container">
      <style>{`
        .dictionary-container {
          padding: 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        .dictionary-header {
          text-align: center;
          margin-bottom: 30px;
        }

        .dictionary-header h1 {
          font-size: 2rem;
          color: #333;
          margin-bottom: 10px;
        }

        .dictionary-header p {
          color: #666;
          font-size: 1.1rem;
        }

        .category-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
          gap: 20px;
          margin-bottom: 30px;
        }

        .category-box {
          background: white;
          border-radius: 16px;
          padding: 24px 16px;
          text-align: center;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          border: 3px solid transparent;
        }

        .category-box:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .category-box.active {
          border-color: currentColor;
          transform: translateY(-3px);
        }

        .category-icon {
          font-size: 3rem;
          margin-bottom: 12px;
          display: block;
        }

        .category-name {
          font-size: 1.1rem;
          font-weight: 600;
          color: #333;
          margin-bottom: 4px;
        }

        .category-name-si {
          font-size: 0.9rem;
          color: #666;
        }

        .category-count {
          font-size: 0.8rem;
          color: #999;
          margin-top: 8px;
        }

        .words-section {
          background: white;
          border-radius: 16px;
          padding: 24px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .words-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 24px;
          padding-bottom: 16px;
          border-bottom: 2px solid #f0f0f0;
        }

        .words-title {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .words-title-icon {
          font-size: 2rem;
        }

        .words-title h2 {
          margin: 0;
          font-size: 1.5rem;
          color: #333;
        }

        .words-title-si {
          color: #666;
          font-size: 1rem;
        }

        .back-btn {
          background: #f5f5f5;
          border: none;
          padding: 10px 20px;
          border-radius: 8px;
          cursor: pointer;
          font-size: 1rem;
          transition: all 0.2s ease;
        }

        .back-btn:hover {
          background: #e0e0e0;
        }

        .words-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
          gap: 16px;
        }

        .word-card {
          background: #f8f9fa;
          border-radius: 12px;
          padding: 16px;
          display: flex;
          align-items: center;
          gap: 12px;
          transition: all 0.2s ease;
        }

        .word-card:hover {
          background: #f0f0f0;
          transform: translateX(5px);
        }

        .word-info {
          flex: 1;
        }

        .word-english {
          font-size: 1.1rem;
          font-weight: 600;
          color: #333;
          text-transform: capitalize;
          margin-bottom: 4px;
        }

        .word-sinhala {
          font-size: 1.3rem;
          color: #1a73e8;
          margin-bottom: 4px;
        }

        .word-pronunciation {
          font-size: 0.9rem;
          color: #666;
          font-style: italic;
        }

        .speak-btn {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border: none;
          width: 44px;
          height: 44px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          transition: all 0.2s ease;
          flex-shrink: 0;
        }

        .speak-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
        }

        .speak-btn.playing {
          animation: pulse 1s infinite;
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.1); }
        }

        @media (max-width: 768px) {
          .category-grid {
            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
            gap: 12px;
          }

          .category-box {
            padding: 16px 12px;
          }

          .category-icon {
            font-size: 2.5rem;
          }

          .words-grid {
            grid-template-columns: 1fr;
          }

          .words-header {
            flex-direction: column;
            gap: 16px;
            text-align: center;
          }
        }
      `}</style>

      <div className="dictionary-header">
        <h1>📚 Sinhala Dictionary</h1>
        <p>සිංහල ශබ්දකෝෂය - Click a category to explore words</p>
      </div>

      {!selectedCategory ? (
        <div className="category-grid">
          {categoryKeys.map((key) => {
            const cat = categories[key];
            return (
              <div
                key={key}
                className="category-box"
                style={{ color: cat.color }}
                onClick={() => setSelectedCategory(key)}
              >
                <span className="category-icon">{cat.icon}</span>
                <div className="category-name">{cat.name}</div>
                <div className="category-name-si">{cat.nameSi}</div>
                <div className="category-count">{cat.words.length} words</div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="words-section">
          <div className="words-header">
            <div className="words-title">
              <span className="words-title-icon">{categories[selectedCategory].icon}</span>
              <div>
                <h2>{categories[selectedCategory].name}</h2>
                <span className="words-title-si">{categories[selectedCategory].nameSi}</span>
              </div>
            </div>
            <button className="back-btn" onClick={() => setSelectedCategory(null)}>
              ← Back to Categories
            </button>
          </div>

          <div className="words-grid">
            {categories[selectedCategory].words.map((word, index) => (
              <div key={index} className="word-card">
                <div className="word-info">
                  <div className="word-english">{word.english}</div>
                  <div className="word-sinhala">{word.sinhala}</div>
                  <div className="word-pronunciation">{word.pronunciation}</div>
                </div>
                <button
                  className={`speak-btn ${playingWord === index ? 'playing' : ''}`}
                  onClick={() => handleSpeak(word.sinhala, index)}
                  title="Listen to pronunciation"
                >
                  {playingWord === index ? '⏹️' : '🔊'}
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Dictionary;
